import React from "react";

export default function PopupExample() {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <button
        className="w-full h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed bg-gray-800 text-white active:bg-gray-600 font-bold uppercase text-3xl px-6 py-3 shadow hover:shadow-lg outline-none focus:outline-none j ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(true)}
      >
        Coming Soon!
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-bold">
                    COMING SOON...
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                  </button>
                </div>
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-slate-500 text-lg leading-relaxed">
                  The Guide page is currently undergoing development. Our team is working diligently to ensure that this feature is fully operational as soon as possible.</p>
                  <p className="my-4 text-slate-500 text-lg leading-relaxed">We appreciate your patience and understanding during this time. We will keep you updated on the progress and let you know as soon as the feature is available again.
                  </p>
                </div>
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  {/* <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Go Back
                  </button> */}
                  <button
                    className="bg-gray-800 text-white active:bg-gray-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Okay
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
